import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FlyingClubResult } from '../models/flying-club-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the Flying Club Finder. Calls the AirportsAPI `~/flying-clubs` endpoint. Category
 * facet filtering (Membership / Benefits / Flying / AOPA Network / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
var FlyingClubsService = /** @class */ (function (_super) {
    tslib_1.__extends(FlyingClubsService, _super);
    function FlyingClubsService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'flying-clubs';
        return _this;
    }
    FlyingClubsService.prototype.parse = function (data) {
        return FlyingClubResult.parse(data);
    };
    FlyingClubsService.prototype.getFlyingClubsByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    FlyingClubsService.prototype.getFlyingClubsByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    FlyingClubsService.prototype.getFlyingClubsByState = function (state) {
        return this.getByState(state);
    };
    FlyingClubsService.prototype.getFlyingClubsBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    FlyingClubsService.ngInjectableDef = i0.defineInjectable({ factory: function FlyingClubsService_Factory() { return new FlyingClubsService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: FlyingClubsService, providedIn: "root" });
    return FlyingClubsService;
}(BusinessFinderService));
export { FlyingClubsService };
